export const sidebarData = {
  manuList: [
    {
      manuName: 'Songs',
      subMenu: [
        { name: 'Add Songs', iconName: 'add-songs', route: '/songs/add-songs', allPaths: ['/songs/add-songs'] },
        { name: 'Search Songs', iconName: 'search-songs', route: '/songs/search-songs', allPaths: ['/songs', '/songs/song-detail'] },
      ],
    },
    {
      manuName: 'Playlists',
      subMenu: [
        {
          name: 'Unlimited',
          iconName: 'infinite-icon',
          route: '/unlimited-playlist',
          allPaths: ['/unlimited-playlist', '/unlimited-new-playlist'],
        },
        {
          name: 'Radio',
          iconName: 'edit-playlist',
          route: '/radio-playlist',
          allPaths: ['/radio-playlist', '/radio-new-playlist', '/edit-playlist-secondery', '/edit-playlist-and-server'],
        },
      ],
    },

    {
      manuName: 'Artist',
      subMenu: [{ name: 'Artist', iconName: 'artists', route: '/artists', allPaths: ['/artists'] }],
    },
    {
      manuName: 'Users',
      subMenu: [{ name: '2.0 Users', iconName: 'users', route: '/users/2.0-users', allPaths: ['/users/2.0-users'] }],
    },
    {
      manuName: 'Songs',
      subMenu: [
        {
          name: 'Review Songs',
          iconName: 'reviews-song',
          route: '/songs/review-songs',
          allPaths: ['/songs/review-songs'],
        },
      ],
    },

    {
      manuName: 'Withdrawals',
      subMenu: [
        {
          name: 'Requests',
          iconName: 'withdrawals-icon',
          route: '/withdrawals/requests',
          allPaths: ['/withdrawals/requests'],
        },
      ],
    },
  ],
};

